<template>
  <div>
    <div v-if="!isCollapse" class="top-header">
      <img class="top-logo" :src="companyLogo" />
    </div>
    <Menu
      :default-active="defaultMenu"
      class="el-menu-vertical"
      :collapse="isCollapse"
      @open="handleOpen"
      @close="handleClose"
    >
      <SubMenu
        v-for="(route, k) in usefulPermissionRoutes"
        :key="k"
        :index="route.index"
      >
        <template slot="title">
          <img
            v-if="route.meta.icon"
            class="side-logo"
            :src="`https://xlian-oss-pro-public.oss-cn-hangzhou.aliyuncs.com/mapp/emi/${route.meta.icon}.png`"
          />
          <span class="side-title">{{ route.meta.title }}</span>
        </template>
        <MenuItem
          v-for="(r, j) in route.children"
          :key="j"
          :index="r.index"
          @click.native.stop="handleSelect(k + '-' + j)"
        >
          <span class="sub-side-title">{{ r.meta.title }}</span>
        </MenuItem>
      </SubMenu>
    </Menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import path from 'path'
import Menu from './menu/index'
import SubMenu from './menu/src/submenu.vue'
import MenuItem from './menu/src/menu-item.vue'

export default {
  components: { Menu, SubMenu, MenuItem },
  props: {
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isCollapse: false
      // defaultMenu: this.pathIndex[this.$route.path] || ''
    }
  },
  computed: {
    ...mapGetters(['permission_routes', 'routesMap', 'userInfo', 'pathIndex']),
    companyLogo() {
      return this.userInfo?.companyInfo?.logo
    },
    defaultMenu() {
      return this.pathIndex[this.$route.path] || ''
    },
    usefulPermissionRoutes() {
      const routes = []
      const P_ROUTES = this.filterRoutes(this.permission_routes || [])
      for (let i = 0; i < P_ROUTES.length; i++) {
        P_ROUTES[i].index = i + ''
        routes.push(P_ROUTES[i])
        const children = []
        const C_ROUTES = this.filterRoutes(P_ROUTES[i]?.children || [])
        for (let j = 0; j < C_ROUTES.length; j++) {
          C_ROUTES[j].index = i + '-' + j
          children.push(C_ROUTES[j])
        }
        P_ROUTES[i].children = children
      }
      return routes
    }
  },
  methods: {
    filterRoutes(routes) {
      return (routes || []).filter((_) => !_.hidden && _.state == 1)
    },
    resolvePath(routePath) {
      // console.log(this.basePath, '123')
      // if (isExternal(routePath)) {
      //   return routePath
      // }
      // if (isExternal(this.basePath)) {
      //   return this.basePath
      // }
      return path.resolve(this.basePath, routePath)
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    handleSelect(key, keyPath) {
      this.$router.push({
        path: this.routesMap[key]
      })
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath)
    }
  }
}
</script>

<style scoped lang="less">
.top-header {
  display: flex;
  justify-content: center;
  padding-top: 16px;
  > img {
    height: 90px;
    width: auto;
    display: inline-block;
    // margin: 24px 0;
    max-width: 200px;
  }
}
.el-menu-vertical:not(.el-menu--collapse) {
  height: 100%;
  min-width: 212px;
  min-height: 400px;
  padding: 0 6px;
  box-sizing: border-box;
}
.side-logo {
  height: 20px;
  width: 20px;
  display: inline-block;
}
.side-title {
  padding-left: 8px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 22px;
  user-select: none;
}
.sub-side-title {
  padding-left: 40px;
  user-select: none;
}
// /deep/ .el-menu {
//   border: 0;
//   background: #292f4c;
//   .el-submenu__title {
//     &:hover {
//       background: rgba(57, 66, 106, 1);
//       border-radius: 4px 4px 4px 4px;
//       // line-height: 40px;
//       // height: 40px;
//     }
//     span {
//       color: #fff;
//     }
//   }
//   .el-menu-item {
//     color: #fff;
//     font-size: 14px;
//     font-family: PingFang SC, PingFang SC;
//     font-weight: 600;
//     color: #ffffff;
//     // width: 10px !important;
//     box-sizing: border-box;
//     &:hover {
//       background: rgba(57, 66, 106, 1);
//       border-radius: 4px 4px 4px 4px;
//       // line-height: 40px;
//       // height: 40px;
//     }
//   }
//   .el-menu-item.is-active {
//     // width: 164px;
//     // height: 40px;
//     background: #0085ff;
//     border-radius: 4px 4px 4px 4px;
//     padding: 0;
//     line-height: 50px;
//     // margin: 6px 8px;
//   }
// }
</style>
